import { useEffect, useState } from "react";

// Clerk renders nothing at all until clerk-js has loaded, so a key/domain mismatch (production
// keys are pinned to one domain and 400 everywhere else) used to leave a blank white page with
// no hint of what went wrong. Show the load state, then say so when it never arrives.
export default function ClerkBootFallback() {
  const [timedOut, setTimedOut] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setTimedOut(true), 8000);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white p-6" data-testid="clerk-boot-fallback">
      {timedOut ? (
        <div className="text-center max-w-md" data-testid="clerk-boot-error">
          <h1 className="text-2xl font-bold text-brand-near-black mb-2" style={{ fontFamily: "Montserrat", fontWeight: 700 }}>
            Sign-in didn't load
          </h1>
          <p className="text-brand-muted-grey text-sm">
            The authentication service couldn't be reached from{" "}
            <span className="font-semibold">{window.location.hostname}</span>. Check the Clerk
            publishable key configured for this domain, then reload the page.
          </p>
        </div>
      ) : (
        <div className="text-brand-slate text-lg" data-testid="clerk-boot-loading">Loading…</div>
      )}
    </div>
  );
}
